import * as types from "../action/ActionType";
import { CONSOLIDATE_INVOICE_LIST_INITIAL, INVOICE_LIST_INITIAL} from "../store/InitialStore";

export default function ConsolidateInvoiceSelectReducer(state = CONSOLIDATE_INVOICE_LIST_INITIAL, action) {
  const { type, payload } = action;
  switch (type) {
    case types.CONSOLIDATE_INVOICE_LIST_SELECT:
      return {
        ...state, // Spread the existing state 
        ...payload, // Merge with the new payload
      };
    default:
      return state;
  }
}
